
import React, { useEffect, useState } from "react";
import axios from "axios";
import Grid from "../components/Grid";
import { toast } from "react-toastify";
import IOUModal from "../components/IOUModal";
import ReimbursementModal from "../components/ReimbursementModal";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

export default function IOUPage() {

    const [rows, setRows] = useState([]);

    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10
    });

    const [rowCount, setRowCount] = useState(0);

    const [preview, setPreview] = useState(null);
    const [locations, setLocations] = useState([]);
    const [categories, setCategories] = useState([]);
    const [showIOUModal, setShowIOUModal] = useState(false);
    const [selectedIOU, setSelectedIOU] = useState(null);
    const [selectedSettlement, setSelectedSettlement] = useState(null);
    const [showReimbursementModal, setShowReimbursementModal] = useState(false);
    const [expenseRows, setExpenseRows] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [cashbookDialog, setCashbookDialog] = useState(false);
    const [cashbooks, setCashbooks] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedCashbook, setSelectedCashbook] = useState("");
    const [editIOU, setEditIOU] = useState(null);
    const [allTransactions, setAllTransactions] = useState([]);
    const token = sessionStorage.getItem("token");

    const user = JSON.parse(sessionStorage.getItem("user") || "{}");

    const role = user.role || "";

    const isCompanyAdmin = role === "Company Admin";
    const isAccountant = role === "Accountant";

    useEffect(() => {
        fetchCategories();
        fetchCashBooks();
    }, []);

    useEffect(() => {
        fetchIOU();
    }, [paginationModel.page, paginationModel.pageSize]);

    useEffect(() => {

        const refreshHandler = () => {
            fetchIOU();
        };

        window.addEventListener(
            "pettycash-updated",
            refreshHandler
        );

        return () => {

            window.removeEventListener(
                "pettycash-updated",
                refreshHandler
            );
        };

    }, []);
    // ================= FETCH =================

    const fetchIOU = async () => {

        try {

            const res = await axios.get(
                `${API_BASE_URL}/pettycash/get-transactions`,
                {
                    params: {
                        limit: 1000
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            const all = res.data.data || [];

            setAllTransactions(all);

            const expenses = all.filter(
                tx => tx.transaction_type === "IOUExpense"
            );

            setExpenseRows(expenses);

            const formatted = [];

            all.forEach(tx => {

                // MAIN IOU

                if (tx.transaction_type === "IOU") {

                    formatted.push({
                        ...tx,
                        grid_row_id: `${tx._id}-iou`,
                        row_type: "IOU",
                        original_iou: true
                    });
                }

                // ONLY SETTLEMENT ROW

                // if (
                //     tx.transaction_type === "IOUSettlement" && tx.related_iou
                // ) {
                //
                //     formatted.push({
                //         ...tx,
                //         grid_row_id: `${tx._id}-settlement`,
                //         row_type:
                //             tx.returned_amount > 0
                //                 ? "Money Return"
                //                 : tx.returned_amount < 0
                //                     ? "Extra Claim"
                //                     : "Balanced Settlement"
                //     });
                // }
            });




            setRows(formatted);
            setRowCount(
                res.data.totalRecords || 0
            );


        } catch (error) {

            console.error(
                "Fetch IOU Error:",
                error?.response?.data || error.message
            );

            toast.error(
                error?.response?.data?.message ||
                "Failed to fetch IOU"
            );
        }
    };

    // ================= ACTIONS =================

    const approve = async (id) => {

        try {

            await axios.put(
                `${API_BASE_URL}/pettycash/approve/${id}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            toast.success("Approved");

            fetchIOU();

            window.dispatchEvent(
                new Event("pettycash-updated")
            );

        } catch (error) {

            console.error(
                "Approve Error:",
                error?.response?.data || error.message
            );

            toast.error(
                error?.response?.data?.message ||
                "Approve failed"
            );
        }
    };

    const reject = async (id) => {

        try {

            await axios.put(
                `${API_BASE_URL}/pettycash/reject/${id}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            toast.success("Rejected");

            fetchIOU();

            window.dispatchEvent(
                new Event("pettycash-updated")
            );

        } catch (error) {

            console.error(error);

            toast.error(
                error?.response?.data?.message ||
                "Reject failed"
            );
        }
    };

    const issue = async (id) => {

        try {

            await axios.post(
                `${API_BASE_URL}/pettycash/issue/${id}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            toast.success("Success");

            fetchIOU();

            window.dispatchEvent(
                new Event("pettycash-updated")
            );

        } catch (error) {

            console.error(
                "Issue Error:",
                error?.response?.data || error.message
            );

            toast.error(
                error?.response?.data?.message ||
                "Issue failed"
            );
        }
    };

    const received = async (id) => {

        try {

            await axios.post(
                `${API_BASE_URL}/pettycash/confirm-received/${id}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            toast.success("Confirmed");

            fetchIOU();

        } catch (error) {

            console.error(
                "Received Error:",
                error?.response?.data || error.message
            );

            toast.error(
                error?.response?.data?.message ||
                "Confirm failed"
            );
        }
    };

    const fetchCashBooks = async () => {

        try {

            const res = await axios.get(
                `${API_BASE_URL}/cashbook/get`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setCashbooks(res.data.data || []);
            setLocations(res.data.data || []);

        } catch (err) {

            console.log(err);

            toast.error("Failed to load CashBooks");
        }
    };

    const fetchCategories = async () => {

        try {

            const res = await axios.get(
                `${API_BASE_URL}/cashbook-category/get`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            const paymentCategories =
                res.data.data.filter(
                    c => c.type === "Payment"
                );

            setCategories(paymentCategories);

        } catch (err) {

            toast.error("Error loading categories");
        }
    };

    const handleLinkCashbook = async () => {

        if (!selectedCashbook) {

            toast.error(
                "Select cashbook"
            );

            return;
        }

        try {

            await axios.put(
                `${API_BASE_URL}/pettycash/link-cashbook/${selectedRow._id}`,
                {
                    cash_book: selectedCashbook
                },
                {
                    headers: {
                        Authorization:
                            `Bearer ${token}`
                    }
                }
            );

            toast.success(
                "Cashbook linked"
            );

            setCashbookDialog(false);

            setSelectedCashbook("");

            fetchIOU();

            window.dispatchEvent(
                new Event("pettycash-updated")
            );

        } catch (err) {

            toast.error(
                err.response?.data?.message ||
                "Error"
            );
        }
    };

    const handleOpenCashbookDialog =
        async (row) => {

            setSelectedRow(row);

            await fetchCashBooks();

            setCashbookDialog(true);
        };

    // ================= STATUS COLOR =================

    const statusColor = (status) => {

        switch (status) {

            case "Requested":
                return "bg-gray-200 text-gray-700";

            case "Approved":
                return "bg-blue-200 text-blue-700";

            case "SettlementApproved":
                return "bg-blue-200 text-blue-700";

            case "Issued":
                return "bg-orange-200 text-orange-700";

            case "Received":
                return "bg-purple-200 text-purple-700";

            case "SettlementPending":
                return "bg-yellow-200 text-yellow-700";

            case "MoneyIssued":
                return "bg-indigo-200 text-indigo-700";

            case "Settled":
                return "bg-green-200 text-green-700";

            default:
                return "";
        }
    };

    const displayRows = React.useMemo(() => {

        const finalRows = [];

        rows.forEach(row => {

            // MAIN ROW
            finalRows.push(row);

            // EXPENSE ROWS
            if (
                row.transaction_type === "IOU" &&
                expandedRows.includes(row._id)
            ) {

                const expenseData = expenseRows.filter(tx => {

                    const relatedId =
                        typeof tx.related_iou === "object"
                            ? tx.related_iou?._id
                            : tx.related_iou;

                    return String(relatedId) === String(row._id);
                });

                expenseData.forEach(exp => {

                    finalRows.push({
                        ...exp,
                        grid_row_id: `${exp._id}-expense`,
                        is_expense_row: true,
                        parent_iou: row._id
                    });

                });

                const settlementRow = allTransactions.find(tx => {
                    if (tx.transaction_type !== "IOUSettlement") {
                        return false;
                    }

                    const relatedId =
                        typeof tx.related_iou === "object"
                            ? tx.related_iou?._id
                            : tx.related_iou;

                    return String(relatedId) === String(row._id);
                });

                if (settlementRow) {
                    finalRows.push({
                        ...settlementRow,
                        grid_row_id:
                            `${settlementRow._id}-nested-settlement`,
                        is_settlement_row: true,
                        parent_iou: row._id
                    });
                }
            }
        });

        return finalRows;

    }, [rows, expandedRows, expenseRows, allTransactions]);

    // ================= COLUMNS =================

    const columns = [

        // EXPAND

        {
            field: "expand",
            headerName: "",
            width: 70,

            renderCell: (p) => {

                if (
                    p.row.transaction_type !== "IOU"
                ) {
                    return null;
                }

                const expanded =
                    expandedRows.includes(p.row._id);

                return (

                    <button
                        onClick={() => {

                            if (expanded) {

                                setExpandedRows(prev =>
                                    prev.filter(x => x !== p.row._id)
                                );

                            } else {

                                setExpandedRows(prev => [
                                    ...prev,
                                    p.row._id
                                ]);
                            }
                        }}
                    >
                        {expanded ? "▼" : "▶"}
                    </button>
                );
            }
        },

        // CODE

        {
            field: "transaction_code",
            headerName: "Code",
            flex: 1
        },

        // CATEGORY

        {
            field: "cashbook_code",
            headerName: "CashBook",
            flex: 1,
            renderCell: (p) => {

                const cashbook =
                    p.row.cash_book?.cash_book_code || "-";

                return (
                    <div className="flex justify-center items-center w-full h-full">
                <span className="font-medium text-gray-700">
                    {cashbook}
                </span>
                    </div>
                );
            }
        },

        // TYPE

        {
            field: "transaction_type",
            headerName: "Type",
            flex: 1,
            renderCell: (p) => {

                // EXPENSE ROW

                if (p.row.is_expense_row) {

                    return (
                        <div className="ml-6 text-red-500 font-semibold">
                            IOU Expense
                        </div>
                    );
                }

                // SETTLEMENT ROW

                if (p.row.is_settlement_row) {

                    return (
                        <div className="ml-6 text-yellow-700 font-bold ">
                            IOU Settlement
                        </div>
                    );
                }

                return p.row.transaction_type;
            }
        },

        // AMOUNT

        {
            field: "amount",
            headerName: "Amount",
            flex: 1,

            renderCell: (p) => {

                    // =====================================
                    // IOU ROW
                    // =====================================

                if (
                    p.row.transaction_type === "IOU"
                ) {

                    return (
                        <span className="text-green-700 font-bold">
                            + Rs {p.row.amount}
                        </span>
                    );
                }

                // =====================================
                // IOU EXPENSE ROW
                // =====================================

                if (p.row.is_expense_row) {

                    return (
                        <span className="text-red-500 ml-6 font-bold">
                            - Rs {p.row.amount}
                        </span>
                    );
                }

                // =====================================
                // IOU SETTLEMENT ROW
                // =====================================

                if (
                    p.row.transaction_type ===
                    "IOUSettlement"
                ) {

                    const value =
                        p.row.returned_amount ?? 0;

                    return (

                        <div className="ml-6">

                            <span
                                className={
                                    value > 0
                                        ? "text-red-600 font-bold italic bg-yellow-50 px-2 py-1 rounded"
                                        : value < 0
                                            ? "text-green-700 font-bold italic bg-yellow-50 px-2 py-1 rounded"
                                            : "text-gray-700 font-bold italic bg-yellow-50 px-2 py-1 rounded"
                                }
                            >
                                {
                                    value > 0
                                        ? ` - Rs ${Math.abs(value)}`
                                        : value < 0
                                            ? ` + Rs ${Math.abs(value)}`
                                            : " Rs 0"
                                }
                            </span>

                        </div>
                    );
                }

                return `Rs ${p.row.amount}`;
            }
        },

        // BALANCE

        ...(isAccountant || isCompanyAdmin
        ? [
                {
                    field: "balance",
                    headerName: "Current Balance",
                    flex: 1,

                    renderCell: (params) => {

                        const balance =
                            params.row.cash_book?.current_balance ?? 0;

                        return (
                            <div className="w-full h-full flex items-center justify-center">
                        <span className="bg-green-100 text-green-600 px-3 py-1 rounded-full text-sm font-semibold">
                            Rs {balance}
                        </span>
                            </div>
                        );
                    }
                },
            ] : []),

        // DESCRIPTION

        {
            field: "description",
            headerName: "Description",
            flex: 2
        },

        // FILES

        {
            field: "files",
            headerName: "Files",
            flex: 1,

            renderCell: (p) => (

                <div className="flex gap-1">

                    {p.row.attachments?.map((file, i) => {

                        const url =
                            `${IMAGE_BASE_URL}/${file}`;

                        return (

                            <img
                                key={i}
                                src={url}
                                alt=""
                                className="w-8 h-8 rounded cursor-pointer"
                                onClick={() => setPreview(url)}
                            />
                        );
                    })}
                </div>
            )
        },

        // DATE

        {
            field: "date",
            headerName: "Date",
            flex: 1,

            renderCell: (p) =>
                new Date(
                    p.row.transaction_date
                ).toLocaleDateString()
        },

        // STATUS

        {
            field: "status",
            headerName: "Status",
            flex: 1,

            renderCell: (p) => (

                <span
                    className={`px-2 py-1 rounded text-xs ${statusColor(
                        p.row.iou_status
                    )}`}
                >
                    {p.row.iou_status}
                </span>
            )
        },

        // ACTIONS

        {
            field: "action",
            headerName: "Action",
            flex: 2,

            renderCell: (p) => {

                const row = JSON.parse(JSON.stringify(p.row));

                // EXPENSE ROW

                if (row.is_expense_row) {

                    return (
                        <span className="text-gray-400">
                    Expense
                </span>
                    );
                }

                return (

                    <div className="flex gap-2 items-center justify-center w-full h-full">

                        {isCompanyAdmin ? (

                            <>
                                {/* APPROVE IOU */}

                                {   role === "Company Admin" &&
                                    String(row.transaction_type) === "IOU" &&
                                    String(row.iou_status) === "Requested" && (

                                        <>
                                            <button
                                                onClick={() => approve(row._id)}
                                                className="bg-green-600 text-white px-2 py-1 rounded text-xs"
                                            >
                                                Approve
                                            </button>

                                            <button
                                                onClick={() => reject(row._id)}
                                                className="bg-red-600 text-white px-2 py-1 rounded text-xs"
                                            >
                                                Reject
                                            </button>
                                        </>
                                    )}

                                {row.iou_status === "Settled" && (

                                    <span className="text-green-600 font-bold">
                                        Done
                                    </span>
                                )}
                            </>

                        ) : (

                            <>
                                {
                                    isAccountant &&
                                    (
                                        // NORMAL IOU EDIT
                                        (
                                            row.transaction_type === "IOU" &&
                                            row.iou_status === "Requested"
                                        )

                                        ||

                                        // SETTLEMENT EDIT
                                        (
                                            row.transaction_type === "IOUSettlement" &&
                                            row.iou_status === "SettlementPending"
                                        )
                                    ) && (

                                        <button
                                            onClick={() => {

                                                if (row.transaction_type === "IOU") {

                                                    setEditIOU(row);

                                                    setShowIOUModal(true);

                                                } else {

                                                    setSelectedSettlement(row);

                                                    const originalIOU = rows.find(
                                                        r =>
                                                            r.transaction_type === "IOU" &&
                                                            r._id === row.related_iou
                                                    );

                                                    setSelectedSettlement(row);

                                                    setSelectedIOU(originalIOU || null);

                                                    setShowReimbursementModal(true);

                                                    setShowReimbursementModal(true);
                                                }
                                            }}
                                            className="bg-blue-600 text-white px-2 py-1 rounded text-xs"
                                        >
                                            Edit
                                        </button>
                                    )
                                }

                                {
                                    isAccountant &&
                                    row.transaction_type === "IOU" &&
                                    row.iou_status === "Approved" &&
                                    !row.cash_book && (

                                        <button
                                            onClick={() => handleOpenCashbookDialog(p.row)}
                                            className="bg-blue-600 text-white px-2 py-1 rounded text-xs"
                                        >
                                            Link Cashbook
                                        </button>
                                    )
                                }

                                {
                                    isAccountant &&
                                    row.transaction_type === "IOU" &&
                                    row.iou_status === "Approved" &&
                                    row.cash_book &&
                                    (
                                        <button
                                            onClick={() => issue(row._id)}
                                            className="bg-yellow-600 text-white px-2 py-1 rounded text-xs"
                                        >
                                            Money Issued
                                        </button>
                                    )
                                }

                                {/* USER ADD EXPENSE */}

                                {
                                    isAccountant &&
                                    row.transaction_type === "IOU" &&
                                    row.iou_status === "MoneyIssued" && (

                                        <div className="w-full h-full flex justify-center items-center">

                                            <button
                                                onClick={() => {

                                                    setSelectedIOU(row);

                                                    setSelectedSettlement(null);

                                                    setShowReimbursementModal(true);

                                                }}
                                                className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-2 py-1 rounded text-xs"
                                            >
                                                + Add Expenses
                                            </button>
                                        </div>
                                    )}

                                {/* CASE 01 — USER RETURN MONEY */}

                                {
                                    isAccountant &&
                                    row.transaction_type === "IOUSettlement" &&
                                    row.iou_status === "SettlementApproved" &&
                                    row.returned_amount > 0 && (

                                        <button
                                            onClick={() => issue(row._id)}
                                            className="bg-orange-600 text-white px-2 py-1 rounded text-xs"
                                        >
                                            Return Money
                                        </button>
                                    )}

                                {
                                    isAccountant &&
                                    row.transaction_type === "IOUSettlement" &&
                                    row.iou_status === "SettlementApproved" &&
                                    row.returned_amount < 0 && (
                                        <button
                                            onClick={() => issue(row._id)}
                                            className="bg-yellow-600 text-white px-2 py-1 rounded text-xs"
                                        >
                                            Money Issued
                                        </button>
                                    )
                                }


                                {row.iou_status === "Settled" && (

                                    <span className="text-green-600 font-bold">
                                         Done
                                    </span>
                                )}
                            </>
                        )}
                    </div>
                );
            }
        }
    ];

    return (

        <div className="p-6">

            {/* HEADER */}

            <div className="flex justify-between items-center mb-6">

                <h2 className="text-3xl font-bold text-green-700">
                    IOU Management
                </h2>

                {!isCompanyAdmin && (

                    <button
                        onClick={() => {
                            setShowIOUModal(true);
                        }}
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-800"
                    >
                        + Add IOU
                    </button>
                )}
            </div>

            {/* GRID */}

            <div className="bg-white p-4 rounded shadow">

                <Grid
                    rows={displayRows}
                    columns={columns}
                    getRowId={(row) => row.grid_row_id || row._id}
                    rowCount={displayRows.length}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                />
            </div>

            {/* IMAGE PREVIEW */}

            {preview && (

                <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">

                    <img
                        src={preview}
                        alt=""
                        className="max-h-[80%]"
                    />

                    <button
                        onClick={() => setPreview(null)}
                        className="absolute top-5 right-5 text-white text-2xl"
                    >
                        ✕
                    </button>
                </div>
            )}

            {/* IOU MODAL */}

            <IOUModal
                open={showIOUModal}
                editData={editIOU}
                onClose={() => {
                    setShowIOUModal(false);
                    setEditIOU(null);
                }}
                categories={categories}
                cashbooks={locations}
                onSuccess={() => {
                    fetchIOU();
                    setShowIOUModal(false);
                    setEditIOU(null);

                    window.dispatchEvent(
                        new Event("pettycash-updated")
                    );
                }}
            />

            {/* REIMBURSEMENT MODAL */}

            <ReimbursementModal
                open={showReimbursementModal}
                editData={selectedSettlement}
                onClose={() => {

                    setShowReimbursementModal(false);

                    setSelectedSettlement(null);
                }}
                selectedCashBook={selectedIOU?.cash_book}
                relatedIOU={selectedIOU?._id || null}
                selectedSettlement={selectedSettlement}
                selectedIOU={selectedIOU}
                onSuccess={() => {
                    fetchIOU();
                }}
            />

            <Dialog
                open={cashbookDialog}
                onClose={() =>
                    setCashbookDialog(false)
                }
                maxWidth="sm"
                fullWidth
            >

                <DialogTitle>
                    Link Cashbook
                </DialogTitle>

                <DialogContent>

                    <select
                        className="
                w-full
                border
                p-3
                mt-3
                rounded
            "
                        value={selectedCashbook}
                        onChange={(e) =>
                            setSelectedCashbook(
                                e.target.value
                            )
                        }
                    >

                        <option value="">
                            Select Cashbook
                        </option>

                        {
                            cashbooks.map(book => (

                                <option
                                    key={book._id}
                                    value={book._id}
                                >
                                    {book.cash_book_code} - {book.category?.category_name || "No Category"}
                                </option>
                            ))
                        }

                    </select>

                </DialogContent>

                <DialogActions>

                    <Button
                        onClick={() =>
                            setCashbookDialog(false)
                        }
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleLinkCashbook}
                    >
                        Link
                    </Button>

                </DialogActions>

            </Dialog>

        </div>
    );
}